import { ReactElement } from 'react';
import { Field, useFormikContext } from 'formik';
import { TileRadioAccessible, IndividualFormNominate, CompanyFormNominate } from '@components';
import { NominationInfoDisplayObject } from '@services/FormFieldConfig';
import { iNominationFormValues } from '@services/NominationService';
import { tile } from '@interfaces/interfaces';

import styles from './NominationStep6.module.scss';

const INVALID_FILE_SIZE_ERROR_MESSAGE = 'Sorry, this file is either too large (must be less than 4MB) or it’s a file type we don’t accept. Accepted file types include: doc, docx, xls, xlsx, csv, jpeg, png, pdf, txt.';

function NominationStep6(): ReactElement {
  const { values }: { values: iNominationFormValues } = useFormikContext();
  const tSVBoatingMaringOffenceStr = values.IsMarineOffence || values.IsTsvOffence ? 'vessel' : 'vehicle';
  const IndividualOption = (): ReactElement => (
    <>
      <div>Person</div>
    </>
  );

  const OrganisationOption = (): ReactElement => (
    <>
      <div>Company</div>
    </>
  );

  const TILE_DATA: tile[] = [
    {
      body: <IndividualOption />,
      value: 'Person',
    },
    {
      body: <OrganisationOption />,
      value: 'Company',
    },
  ];

  return (
    <>
      <div>
        <div className="vfH2">Someone else was the person in possession of the {tSVBoatingMaringOffenceStr} at the time of the offence</div>
        <Field
          name="WhoAreYouNominating"
          title="Are you nominating a person or company? "
          component={TileRadioAccessible}
          tileData={TILE_DATA}
          wrapTiles
          isMandatory
          info={{
            caption: 'Your nominee must be over 18 years of age.',
            tileValue: 'individual'
          }}
          orientationRow />
        {values.WhoAreYouNominating && (
          <div className={styles.requiredDetails}>
            {values.WhoAreYouNominating === 'Person' && (
              <>
                <p className={styles.bold}>Driver Details</p>
                <p className={styles.details}>
                  Please provide the details of the person you are nominating, who was in possession of the {tSVBoatingMaringOffenceStr} at the time of the offence.
                </p>
              </>
            )}
            {values.WhoAreYouNominating === 'Company' && (
              <>
                <p className={styles.bold}>Details of the company you are nominating</p>
              </>
            )}
          </div>
        )}
        {values.WhoAreYouNominating === 'Person' && <IndividualFormNominate displayObject={NominationInfoDisplayObject} currentStepNo="step6" />}
        {values.WhoAreYouNominating === 'Company' && <CompanyFormNominate displayObject={NominationInfoDisplayObject} currentStepNo="step6" />}
        {values.WhoAreYouNominating === 'Person' && <p>If your Nomination Statement is accepted, the fine will be withdrawn and re-issued to the nominated driver for them to pay. <br /><br /> The driver can reject your nomination. If this happens, the fine will be re-issued back to you.</p>}
        {values.WhoAreYouNominating === 'Company' && <p>If your Nomination Statement is accepted, the fine will be withdrawn and reissued to the responsible company. <br /><br /> The company nominated can reject the nomination. If this happens, the fine will be reissued to you.</p>}
      </div>
    </>
  );
}

export { NominationStep6, INVALID_FILE_SIZE_ERROR_MESSAGE };
